import axios from 'axios';
import environment from './environment';
import { ReducersTypes } from '../redux/reducers/Models';
import { Store } from '@reduxjs/toolkit';
import { setUser } from '@/redux/ducks/user';

const api = axios.create({
    baseURL: environment.api.baseUri,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        'x-api-key': environment.api.apiKey
    }
});

export const setupAxiosInterceptors = (store: Store<ReducersTypes>) => {
    const { dispatch } = store;
    api.interceptors.request.use(
        async (config) => {
            try {
                const user = store.getState().userReducer;

                if (!user?.apiKey) {
                    try {
                        const response = await axios.get(`${config.baseURL}/v1/customers/parameters`, {
                            params: {
                                companyIdentification: environment.api.companyIdentification,
                                channelCode: environment.api.channel,
                            }
                        });
                        const apiKey = response?.data?.data?.frontApiKey ?? "";
                        dispatch(setUser({ apiKey }));
                        config.headers['x-api-key'] = apiKey;
                    } catch (error) {}
                } else {
                    config.headers['x-api-key'] = user?.apiKey;
                }
                
                if (user?.accessToken) {
                    config.headers.accesstoken = String(user.accessToken);
                }

                if (user?.accessTokenTickets) {
                    config.headers.accesstoken = String(user.accessTokenTickets);
                }

            } catch (error) {}

            return config;
        }
    );
    api.interceptors.response.use(
        response => response,
        (error) => {
            if (error?.response?.status === 401) {
                window.location.href = '/';
            }
            return Promise.reject(error);
        }
    );
};

export default api;